import React, { ReactNode, useEffect, useState } from "react";
import GuestHeader from "./GuestHeader";
import Footer from "./Footer";

type GuestLayoutProps = {
  children: ReactNode;
};

const SCROLL_SHOW_THRESHOLD = 400;

const GuestLayout: React.FC<GuestLayoutProps> = ({ children }) => {
  const [showGoTop, setShowGoTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setShowGoTop(window.scrollY > SCROLL_SHOW_THRESHOLD);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="w-full min-h-screen bg-white">
      <GuestHeader />
      {children}
      <Footer />
      <button
        type="button"
        aria-label="Go to top"
        onClick={() =>
          window.scrollTo({ top: 0, behavior: "smooth" })
        }
        className={`fixed bottom-6 right-4 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-green-600 text-white shadow-lg transition-all duration-300 hover:bg-green-700 hover:shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2 md:right-8 ${
          showGoTop
            ? "pointer-events-auto translate-y-0 opacity-100"
            : "pointer-events-none translate-y-2 opacity-0"
        }`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
          aria-hidden
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5 15l7-7 7 7"
          />
        </svg>
      </button>
    </div>
  );
};

export default GuestLayout;
